$('input').blur(function(){
    tmpval = $(this).val();
    if(tmpval == '') {
        $(this).removeClass('not-empty');
    } else {
        $(this).addClass('not-empty');
    }
});
//form subscripció paper
if ( $( "form#form5" ).length ) {
	$('.form5-elem59').hide();
	$('input[type=radio][name=58]').change(function() {
	    if (this.value == 'Rebut bancari') {
	        $('.form5-elem59').fadeIn();
	        $('.form5-elem58 label').addClass('open');
	         $( ".form5-elem59 input#field_59_pais" ).focus();
	    }
	    else {
	        $('.form5-elem59').hide();
	        $('.form5-elem58 label').removeClass('open');
	    }
	});
}

